@if (isVisible()) {
    <ol>
    <li *ngFor="let breadcrumb of breadcrumbs$ | async; let i = index; let last = $last">
        <a
        *ngIf="i != (breadcrumbs$ | async)?.length - 1"
        [href]="breadcrumb.url"
        >{{ breadcrumb.label | translate }}
        </a
        >
        <span
        class="breadcrumb-last-li"
        *ngIf="i == (breadcrumbs$ | async)?.length - 1"
        >
        {{ breadcrumb.label | translate }}
        </span>
        @if (i !== (breadcrumbs$ | async)?.length - 1) {
            <span class="divider"> / </span>
        }
    </li>
    </ol>
}
